export default "__VITE_ASSET__LbctVHob__"